export default __webpack_public_path__ + "static/media/CrosswordISAs.ea28cca2.svg";